// Vercel BotID (Standard) client init. Runs once on the client for every route
// (Next.js instrumentation-client entrypoint, supported on 15.3+), loading the
// invisible challenge script so browser POSTs to the protected paths below carry
// a verifiable token. The matching server checks live in each route via
// checkBotId() from 'botid/server'.
//
// Only WEB traffic is protected: the native iOS app has no browser/token, so the
// server guards skip BotID for app requests (identified by the X-Device-Id header
// on analyze-grass and the absence of an Origin header on upload/image). Keep this
// protect list in sync with those server-side checkBotId() call sites.
import { initBotId } from 'botid/client/core'

initBotId({
  protect: [
    { path: '/api/ai/analyze-grass', method: 'POST' },
    { path: '/api/upload/image', method: 'POST' },
  ],
})
